"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _navMenu = require("../styles/navMenu");

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function getIconColor(a) {
  var b = a.selected,
      c = a.hovered,
      d = a.focused,
      e = a.linkColour,
      f = a.linkHoverColor;
  return b ? "white" : c || d ? f : e;
}

var NavigationLink = function (a) {
  function b() {
    var a;
    return (0, _classCallCheck2["default"])(this, b), a = c.call(this), a.toggleHovered = function () {
      a.setState(function (a) {
        var b = a.hovered;
        return {
          hovered: !b
        };
      });
    }, a.toggleFocus = function () {
      a.setState(function (a) {
        var b = a.focused;
        return {
          focused: !b
        };
      });
    }, a.state = {
      hovered: !1,
      focused: !1
    }, a;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.onClick,
          c = a.icon,
          d = a.label,
          e = a.selected,
          f = a.className,
          g = a.rounded,
          h = this.state,
          i = h.hovered,
          j = h.focused,
          k = a.linkColour || "nevada",
          l = a.linkHoverColor || "black",
          m = getIconColor({
        selected: e,
        hovered: i,
        focused: j,
        linkColour: k,
        linkHoverColor: l
      });
      return _react["default"].createElement("button", {
        "data-cy": "nav-item-".concat(d.replace(/\s/g, "")),
        type: "button",
        className: (0, _classnames["default"])((0, _navMenu.MENU_LINK)({
          selected: e,
          rounded: g,
          linkColour: k,
          linkHoverColor: l
        }), f),
        onClick: b,
        onMouseEnter: this.toggleHovered,
        onMouseLeave: this.toggleHovered,
        onFocus: this.toggleFocus,
        onBlur: this.toggleFocus
      }, c ? _react["default"].createElement(_Icon["default"], {
        name: c,
        size: 20,
        color: m
      }) : _react["default"].createElement("div", {
        className: _navMenu.EMPTY_MENU_LINK_ICON
      }), _react["default"].createElement("p", null, d));
    }
  }]), b;
}(_react.Component);

exports["default"] = NavigationLink;